import * as React from 'react';
import PropTypes from 'prop-types';
import {Icon} from "semantic-ui-react";
import {IconMenu} from "material-ui";
import {InkButton} from "./index";

const _ExtensionMenu = (Component) => ({children, loading, ...props}) => (
	<Component iconButtonElement={<InkButton><Icon name={loading ? 'spinner' : 'ellipsis vertical'} loading={loading}/></InkButton>}
	           anchorOrigin={{horizontal: 'right', vertical: 'top'}}
	           targetOrigin={{horizontal: 'right', vertical: 'top'}}
	           {...props}
	>
		{children}
	</Component>
);



const ExtensionMenu = _ExtensionMenu(IconMenu);
const {iconButtonElement, ...iconMenuTypes} = IconMenu.propTypes;
ExtensionMenu.propTypes = {
	...iconMenuTypes,
	loading: PropTypes.bool
};

ExtensionMenu.defaultProps = {
	loading: false
};

export default ExtensionMenu;


// WEBPACK FOOTER //
// ./src/extensions/ExtensionMenu.js